<template>
  <div class="base-box">
    <van-field
      v-model="params.login"
      class="input-item"
      label="登录名"
      required
      placeholder="包含字母、字数且不能是汉字"
    ></van-field>
    <van-field
      class="input-item"
      :type="isShowPW ? 'password' : ''"
      label="密码"
      required
      :right-icon="isShowPW ? 'closed-eye' : 'eye-o'"
      @click-right-icon="isShowPW = !isShowPW"
      v-model="params.password"
      placeholder="包含字母数字且不能有空格"
    ></van-field>
    <van-field
      class="input-item"
      :type="isShowPW2 ? 'password' : ''"
      label="确认密码"
      required
      :right-icon="isShowPW2 ? 'closed-eye' : 'eye-o'"
      @click-right-icon="isShowPW2 = !isShowPW2"
      v-model="params.password2"
      placeholder="请再次输入您的登录密码"
    ></van-field>
    <van-field
      v-model="params.name"
      class="input-item"
      label="单位名称"
      required
      placeholder="请输入单位名称"
    ></van-field>
    <van-field
      v-model="params.code"
      class="input-item"
      label="信用代码"
      required
      placeholder="请输入统一社会信用代码"
    ></van-field>
    <van-field
      v-model="params.representName"
      class="input-item"
      label="姓名"
      required
      placeholder="请输入您的姓名"
    ></van-field>
    <van-field
      v-model="params.mobile"
      class="input-item"
      label="手机号码"
      required
      placeholder="请输入手机号码"
    ></van-field>
    <van-field
      v-model="params.fullAddress"
      class="input-item"
      label="通讯地址"
      required
      placeholder="请输入通讯地址"
    ></van-field>
    <van-button class="successedBtn" type="primary" size="large" @click="next">完成</van-button>
    <van-checkbox
      class="rule-box"
      checked-color="#228ccd"
      v-model="checked"
      icon-size="16px"
    >
      我已阅读
      <span @click.stop="goHerf">《入会须知》</span>
    </van-checkbox>
  </div>
</template>

<script>
import { Field, Button, Checkbox, Toast, Popup, Cell, Picker } from "vant";
import { fastRegisterMember} from "@/api/login";
import { getUser } from "@/api/dictionary";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
      params: {
        fullAddress: null,
        mobile: null,
        code: null,
        password: null,
        password2: null,
        name:null,
        login: "",
      },
      checked: false,
      isShowPW: true,
      isShowPW2: true,
      selectModel: false,
      memberName: "",
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Picker.name]: Picker,
  },
  computed: {
    ...mapState(["memberTypeList"]),
    ...mapGetters(["GROUP_TYPE"]),
  },
  methods: {
    ...mapActions([,"securityCheck"]),
    ...mapMutations(["setMemberInfo"]),
    getUserInfo() {
      return new Promise((resolve) => {
        getUser().then((res) => {
          if (res.success) {
            this.userInfo = res.result;
            this.setMemberInfo(res.result);
            setSessionStore("memberId", res.result.id);
            resolve();
          } else {
            Toast("用户信息获取失败");
          }
        });
      });
    },
    register() {
      let params = this.params;
      this.params.memberCategory=2;
      this.params.memberType=9;
      fastRegisterMember(params).then((res) => {
        if (res.success) {
            Toast.success("注册成功");
            this.submit();
        } else if (res.messageCode == 110002) {
          Toast.fail("手机号码已经注册");
        } else if (res.messageCode == 110001) {
          Toast.fail("登录名已经注册");
        }
      });
    },
    submit() {
      var params = {
        username: this.params.login,
        password: this.params.password,
        memberCategory: 2,
        grant_type: "password",
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456,
      };
      this.securityCheck(params)
        .then((res) => {
          this.getUserInfo()
            .then((res) => {
              this.$router.push({ name: "MeetingList" });
            })
            .catch(() => {
               Toast.fail("用户信息获取失败");
            });
        })
        .catch((res) => {
           Toast.fail("登录失败");
        });
    },
    goHerf() {
      this.$router.push({ path: "/rule" });
    },
    async next() {
      let isChecked = this.$regexp.password(this.params.password),
        regexpPassword = this.$regexp.chinese(this.params.password);
      if (!this.params.login) {
        Toast("请输入登录名!");
        return;
      }
      if (!this.params.password || !isChecked || regexpPassword) {
        Toast("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格!");
        return;
      }
      if (this.params.password !== this.params.password2) {
        Toast("两次输入的密码不正确!");
        return;
      }
      if (!this.params.name) {
        Toast("请输入单位名称!");
        return;
      }
      if (!this.params.representName) {
        Toast("请输入姓名！");
        return;
      }
      if (!this.params.mobile) {
        Toast("请输入手机号码！");
        return;
      }
      if (!this.params.fullAddress) {
        Toast("请输入通讯地址！");
        return;
      }
      if (!this.checked) {
        Toast("请阅读入会须知！");
        return;
      }
      this.register();
    },
  },
  mounted() {
    this.params.memberCategory = this.$route.query.memberCategory;
  },
};
</script>

<style lang="less" scoped>
  .van-cell--required::before{ left:0!important}
  .input-item {
    padding-right:0;
    padding-top: 0;
    padding-bottom: 12px;
    i {
      color: #aaa;
    }
    & + .input-item {
      margin-top:20px;
    }
  }
  /deep/.van-field__label{ width:2.2rem}
  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }
  .rule-box{justify-content: center; margin-bottom: 20px;}
</style>